// extracted by mini-css-extract-plugin
export default {"imgdiv":"c6ffbd1468 aed20dab2d","img":"_9b1f443e0f _5ea0d36b40"};